import { modalRenderer } from '~/modal/modalRendererRegistry';
import { RestrictZoomLevelModalContainer } from './restrictZoomLevelModal.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    RestrictZoomLevels: undefined;
  }
}

modalRenderer.register('RestrictZoomLevels', RestrictZoomLevelModalContainer);
